class DmRewards extends HTMLElement {
  connectedCallback() {
    this.tabBtns = Array.from(this.querySelectorAll('[data-dm-tab-btn]'));
    this.panels = Array.from(this.querySelectorAll('[data-dm-tab-panel]'));

    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.#activate(btn.dataset.dmTabBtn));
    });

    this.querySelectorAll('[data-dm-copy]').forEach((btn) => {
      btn.addEventListener('click', () => this.#copy(btn));
    });
  }

  #activate(name) {
    this.tabBtns.forEach((btn) => {
      const active = btn.dataset.dmTabBtn === name;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.dmTabPanel !== name;
    });
  }

  async #copy(btn) {
    const value = btn.dataset.dmCopy;
    const label = btn.querySelector('[data-dm-copy-label]');
    try {
      await navigator.clipboard.writeText(value);
      if (label) {
        const original = label.textContent;
        label.textContent = 'Copied';
        setTimeout(() => { label.textContent = original; }, 1500);
      }
    } catch {
      /* Clipboard API unavailable — leave the button as-is. */
    }
  }
}

customElements.define('dm-rewards', DmRewards);
